import React from "react";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import ReactPlayer from "react-player";
import Alert from "react-bootstrap/Alert";

import Emoji from "../components/Emoji.js";
import EPG from "../components/EPG.js";
import EnhancedTable from "../components/table/EnhancedTable.js";
import ListAPI from "../api/listAPI.js";
import Channel from "../models/channel.js";
import ChannelOption from "../models/channel_option.js";
import EpgAPI from "../api/epgAPI.js";
import EPGEvent from "../models/epg_event.js";
import EPGItem from "../models/epg_item.js";

import Config from "../config.js";
import { Event, CLICK_RADIO } from "../toolbox/google_analytics.js";

import RecomendacionesView from "./recomendaciones.js";

import "./player.css";

function createData(logo, name, category) {
  return { logo, name, category };
}

const baseEPGUrl = Config.services.api_radio.epg;

export class RadioTab extends React.Component {
  constructor(props) {
    super(props);

    this.randomIDToForceRefresh = 0;
    this.state = {
      entries: [],
      entriesRows: [],
      filterValues: ["Todos"],
      selectedChannel: undefined,
      selectedOptionN: -1,
      playerError: false,
      epgInfo: new Map(),
    };

    this.divPlayer = React.createRef();
    this.onClickonOption = this.onClickonOption.bind(this);
  }

  componentDidMount() {
    EpgAPI.getEPG(baseEPGUrl, false, (response) => {
      var epgFromAPI = new Map();

      var items = response.message;
      for (var i = 0; i < items.length; ++i) {
        var item = items[i];

        var events = [];
        const channelName = item.name;
        const channelEvents = item.events;
        for (var j = 0; j < channelEvents.length; ++j) {
          var event = channelEvents[j];

          const start = event.hi;
          const end = event.hf;
          const title = event.t;
          const description = event.d;
          const cover = event.c;

          events.push(new EPGEvent(start, end, title, description, cover));
        }
        epgFromAPI.set(channelName, new EPGItem(channelName, events));
      }
      this.setState({
        epgInfo: epgFromAPI,
      });
    });

    const test = ""; //TODO Remove
    ListAPI.getRadio(test, false, (response) => {
      var entriesFromApi = [];
      var ambitsNameFromApi = [];
      var countries = response.message.countries;
      for (var i = 0; i < countries.length; ++i) {
        var country = countries[i];
        var ambits = country.ambits;

        for (var j = 0; j < ambits.length; ++j) {
          var ambit = ambits[j];
          var channels = ambit.channels;

          ambitsNameFromApi.push(ambit.name);

          for (var z = 0; z < channels.length; ++z) {
            var channel = channels[z];
            var options = channel.options;

            var channelOptions = [];
            for (var k = 0; k < options.length; ++k) {
              var option = options[k];

              channelOptions.push(
                new ChannelOption(
                  option.format,
                  option.url,
                  option.geo2,
                  option.res,
                  option.lang,
                  channel.extra_info.includes("EMB")
                )
              );
            }

            entriesFromApi.push(
              new Channel(
                channel.name,
                channel.web,
                channel.logo,
                ambit.name,
                channelOptions,
                channel.epg_id,
                channel.extra_info.includes("NONAV")
              )
            );
          }
        }
      }

      var resultRows = entriesFromApi.map((channel) => {
        return createData(channel.logo, channel.name, channel.category);
      });

      this.setState({
        entries: entriesFromApi,
        entriesRows: resultRows,
        filterValues: ambitsNameFromApi,
      });

      const fullURL = window.location.href.split("/");
      if (fullURL.length > 4 && fullURL[4] !== "") {
        const endURL = fullURL[4];
        for (i = 0; i < this.state.entriesRows.length; i++) {
          if (
            decodeURIComponent(endURL) ===
            this.state.entriesRows[i].name.replace(/\s/g, "")
          ) {
            this.onClickonRow(this.state.entriesRows[i]);
            break;
          }
        }
      }
    });
  }

  onClickonRow(row) {
    var channel;
    for (var i = 0; i < this.state.entries.length; ++i) {
      if (this.state.entries[i].name === row.name) {
        channel = this.state.entries[i];
        break;
      }
    }
    this.setState({
      selectedChannel: channel,
      playerError: false,
    });

    if (channel.cors || channel.options.length === 0) {
      this.setState({ selectedOptionN: -1, playerError: true });
      Event(CLICK_RADIO, channel.name, "");
    } else if (channel.options.length > 0) {
      window.scrollTo(0, this.divPlayer.current.offsetTop);
      this.setState({ selectedOptionN: 0 });
      Event(CLICK_RADIO, channel.name, channel.options[0].url);
    }
    this.props.history.push("/radio/" + channel.name.replace(/\s/g, ""));
  }

  onClickonOption(event) {
    Event(
      CLICK_RADIO,
      this.state.selectedChannel.name + " - OPTION" + event.target.value,
      this.state.selectedChannel.options[event.target.value].url
    );
    this.setState({ selectedOptionN: event.target.value, playerError: false });
  }

  onPlayerError(error, data) {
    console.log(error, data);
    if (
      data !== undefined &&
      data.type !== undefined &&
      data.details !== undefined &&
      data.type !== "mediaError" &&
      data.details !== "bufferStalledError"
    ) {
      this.setState({ playerError: true });
    }
  }

  renderErrorMessage(selectedChannel, selectedOption) {
    var textGEO = "";

    if (selectedOption !== undefined && selectedOption.geo !== null) {
      textGEO =
        "Se trata de una emisión geolocalizada, es posible que estés fuera de la geolocalización permitida.";
    }

    return (
      <div style={{ maxWidth: "450px", margin: "auto" }}>
        <p>
          Este contenido no está disponible en nuestra plataforma web en este
          momento. Te invitamos a verlo desde el sitio{" "}
          <a
            href={selectedChannel.web}
            target="_blank"
            rel="noopener noreferrer"
          >
            web
          </a>{" "}
          donde podrás disfrutar de esta emisión.{" "}
        </p>
        <p>
          ¿Qué tal si exploras nuestro catálogo de canales de televisión o de
          radio mientras tanto? ¡Tenemos muchas opciones para ti!
        </p>
        <p>
          También puedes probar nuestras aplicaciones oficiales para{" "}
          <a
            href="https://www.tdtchannels.com/android"
            target="_blank"
            rel="noopener noreferrer"
          >
            Android
          </a>{" "}
          e{" "}
          <a
            href="https://www.tdtchannels.com/ios"
            target="_blank"
            rel="noopener noreferrer"
          >
            iOS
          </a>
          . ¡Quizá ahí si que tienes suerte y funciona!
        </p>
        <i>{textGEO}</i>
      </div>
    );
  }

  getLabelForOption(option, i) {
    var label = i + 1;
    if (option.geo === "SP") {
      label = "GEO";
    } else if (option.geo === "CAT") {
      label = "GEO CAT";
    }

    if (option.res === "HD") {
      label = "HD";
    } else if (option.res === "SD") {
      label = "SD";
    }

    return label;
  }

  renderPlayer(selectedOption) {
    if (!selectedOption.url.includes("https")) {
      window.open(
        "http://play.tdtchannels.com/player3.html?" + selectedOption.url,
        "mywindow",
        "width=350,height=150,resizable=yes"
      );
      return (
        <div style={{ maxWidth: "450px", margin: "auto" }}>
          <h3 style={{ paddingTop: "10px" }}>
            Esta emisión se abrirá en una pestaña nueva.
          </h3>
        </div>
      );
    }

    return (
      <ReactPlayer
        style={{
          position: "absolute",
          backgroundColor: "transparent",
          padding: "6px",
        }}
        pip={true}
        key={selectedOption.url}
        url={selectedOption.url}
        playing
        controls={true}
        width="100%"
        height="100%"
        onError={(error, data) => this.onPlayerError(error, data)}
      />
    );
  }

  renderRightPanel(selectedChannel) {
    return (
      <FormControl
        variant="outlined"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginLeft: "auto",
        }}
      >
        <Button
          variant="outlined"
          href={selectedChannel.web}
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          <Emoji symbol="🌐" label="cara llorando" />
        </Button>
        {this.state.selectedOptionN !== -1 && (
          <Select
            onChange={this.onClickonOption}
            value={this.state.selectedOptionN}
            style={{
              marginLeft: "10px",
              height: "40px",
            }}
          >
            {!selectedChannel.cors &&
              selectedChannel.options.map((option, i) => {
                return (
                  <MenuItem key={i} value={i}>
                    Emisión {this.getLabelForOption(option, i)}
                  </MenuItem>
                );
              })}
          </Select>
        )}
      </FormControl>
    );
  }

  render() {
    const columns = [
      {
        id: "logo",
        label: "Logo",
      },
      {
        id: "name",
        label: "Canal",
      },
    ];

    const selectedChannel = this.state.selectedChannel;
    const selectedOptionN = this.state.selectedOptionN;
    const playerError = this.state.playerError;

    var selectedOption = undefined;
    if (selectedOptionN >= 0) {
      selectedOption = selectedChannel.options[selectedOptionN];
    }

    if (
      this.randomIDToForceRefresh === 0 &&
      this.state.entriesRows.length !== 0
    ) {
      this.randomIDToForceRefresh = 1;
    }
    return (
      <Grid container style={{ height: "100%" }}>
        <Grid item xs={12} sm={12} md={12} lg={3}>
          <div
            key={this.randomIDToForceRefresh}
            className="left-separator"
            style={{ height: "100%" }}
          >
            <EnhancedTable
              toolbarTitle={"Radio"}
              toolbarIcon={"📻"}
              filterValues={this.state.filterValues}
              dataColumns={columns}
              dataRows={this.state.entriesRows}
              onClickonRow={this.onClickonRow.bind(this)}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={7}>
          <div ref={this.divPlayer}>
            {selectedChannel === undefined && (
              <h2
                className="title-emision"
                style={{
                  paddingTop: "10px",
                  paddingBottom: "20px",
                  paddingLeft: "10px",
                }}
              >
                Selecciona alguna emisora para empezar
              </h2>
            )}
            {selectedChannel !== undefined && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
              >
                <img
                  className="img-logo-channel"
                  src={selectedChannel.logo}
                  alt="logo"
                />
                <p className="title-emision">{selectedChannel.name}</p>
                {this.renderRightPanel(selectedChannel)}
              </div>
            )}
            <Alert
              variant="secondary"
              style={{
                marginLeft: "10px",
                marginRight: "10px",
                marginBottom: "10px",
              }}
            >
              TDTChannels no transmite ni distribuye el contenido de ninguna
              plataforma de medios. En estos momentos estás visualizando la
              información proporcionada, de forma directa, por el servidor
              oficial del emisor (+{" "}
              <a
                href="https://www.tdtchannels.com/aviso-legal/"
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                info
              </a>
              ).
            </Alert>
            <div
              style={{
                height: "100px",
                position: "relative",
              }}
            >
              {selectedChannel !== undefined &&
                selectedOption !== undefined &&
                !playerError && (
                  <div
                    style={{
                      position: "relative",
                      paddingBottom: "75px",
                      height: "0",
                    }}
                  >
                    {this.renderPlayer(selectedOption)}
                  </div>
                )}
              {playerError && (
                <div style={{ marginTop: "250px", textAlign: "center" }}>
                  <h2>
                    ¡Vaya! Ha ocurrido un problema!{" "}
                    <Emoji symbol="😢" label="cara llorando" />
                  </h2>
                  {this.renderErrorMessage(selectedChannel, selectedOption)}
                </div>
              )}
              {selectedChannel !== undefined &&
                selectedChannel.epg !== undefined &&
                selectedChannel.epg !== null && (
                  <Alert
                    variant="primary"
                    style={{
                      marginLeft: "10px",
                      marginRight: "10px",
                      marginTop: "10px",
                    }}
                  >
                    <EPG
                      epgInfo={this.state.epgInfo}
                      epgChannelID={selectedChannel.epg}
                      key={selectedChannel.epg}
                    />
                  </Alert>
                )}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={2}>
          <RecomendacionesView />
        </Grid>
      </Grid>
    );
  }
}

export default RadioTab;
